export enum FileServiceEventsEnum {
  RENDERER_TO_MAIN_DOWNLOAD_FILE_FROM_URL = 'RENDERER_TO_MAIN_DOWNLOAD_FILE_FROM_URL',
  RENDERER_TO_MAIN_DOWNLOAD_CSV_FILE = 'RENDERER_TO_MAIN_DOWNLOAD_CSV_FILE',
  MAIN_TO_RENDERER_FILE_DOWNLOAD_COMPLETED = 'MAIN_TO_RENDERER_FILE_DOWNLOAD_COMPLETED',
  MAIN_TO_RENDERER_FILE_DOWNLOAD_FAILED = 'MAIN_TO_RENDERER_FILE_DOWNLOAD_FAILED',
  RENDERER_TO_MAIN_OPEN_FILE = 'RENDERER_TO_MAIN_OPEN_FILE',
}
